import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { numberFormat } from '@nike/i18n-core';
var includeCurrencyWarning = "\n  You didn't include the currency to use in currency formatting. This is a requirement for proper formatting.\n\n  Possible values are the ISO 4217 currency codes, such as \"USD\" for the US dollar, \"EUR\" for the euro, or \"CNY\" for the Chinese RMB.\n";
/**
 * @memberof ux-tread-currency
 * @description formatCurrency formats a number (or string of a number) into the Nike-approved format for the given locale.
 * Defaults to 'us' locale
 * @param {object} params - Named parameters
 * @param {string|number} params.price -  The number to format
 * @param {string} params.localeForCurrency - BCP 47 language tag
 * @param {string} params.currency - The ISO 4217 currency code to use in currency formatting.
 * @param {...object} params.intlOptions - This is not a named parameter but rather remainder params corresponding to Intl object options. @see{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat#Parameters}
 *
 * @example <caption>Basic implementation example</caption>
 * import { formatCurrency } from '@nike/ux-tread-currency'
 *
 * const formattedDollars = formatCurrency({
 *   price: 100,
 *   localeForCurrency: 'en-US',
 *   currency: 'USD',
 *   minimumSignificantDigit: 2, // this is spread into the intlOptions
 * });
 *
 * @returns {string} The formatted currency or an empty string
 */

export default function formatCurrency(_ref) {
  var price = _ref.price,
      localeForCurrency = _ref.localeForCurrency,
      currency = _ref.currency,
      intlOptions = _objectWithoutProperties(_ref, ["price", "localeForCurrency", "currency"]);

  var opts = _objectSpread(_objectSpread({}, intlOptions), {}, {
    currency: currency
  });

  if (process.env.NODE_ENV !== 'production') {
    if (!opts.currency) {
      // eslint-disable-next-line no-console
      console.warn(includeCurrencyWarning);
    }
  }

  return numberFormat(localeForCurrency, price, opts);
}